import React from "react";
import { Phone, Mail, MapPin, MessageCircle, Globe, Clock } from "lucide-react";
import { BRAND } from "../lib/data";
import LeadForm from "../components/LeadForm";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <section className="bg-navy text-white section-pad">
        <div className="container-x">
          <span className="accent-bar mb-4" />
          <h1 className="font-heading text-4xl md:text-6xl font-extrabold tracking-tight">Get In Touch</h1>
          <p className="mt-4 text-white/80 max-w-2xl">Reach out for a free consultation. Our team responds within 24 hours.</p>
        </div>
      </section>

      <section className="container-x section-pad grid lg:grid-cols-2 gap-12">
        <div className="space-y-6">
          <Card icon={<Phone />} title="Phone" lines={[BRAND.phoneDisplay]} href={`tel:${BRAND.phone}`} testid="contact-phone" />
          <Card icon={<MessageCircle />} title="WhatsApp" lines={[BRAND.phoneDisplay]} href={`https://wa.me/${BRAND.whatsapp}`} testid="contact-whatsapp" />
          <Card icon={<Mail />} title="Email" lines={[BRAND.email]} href={`mailto:${BRAND.email}`} testid="contact-email" />
          <Card icon={<MapPin />} title="Office" lines={[BRAND.address]} testid="contact-office" />
          <Card icon={<Globe />} title="Website" lines={[BRAND.website]} testid="contact-website" />
          <Card icon={<Clock />} title="Working Hours" lines={["Mon - Sat: 10:00 AM - 7:00 PM IST", "Sunday: By appointment"]} testid="contact-hours" />
        </div>

        <div>
          <LeadForm />
        </div>
      </section>

      <section className="container-x pb-20">
        <div className="border border-border rounded-sm overflow-hidden">
          <iframe
            title="Office location"
            src="https://www.google.com/maps?q=Pearls%20West%20Heights%20NSP%20Pitampura%20Delhi%20110034&output=embed"
            className="w-full h-[420px] border-0"
            loading="lazy"
            data-testid="contact-map"
          />
        </div>
      </section>
    </div>
  );
}

function Card({ icon, title, lines, href, testid }) {
  const inner = (
    <div className="border border-border bg-white p-5 rounded-sm flex gap-4 items-start lift-card" data-testid={testid}>
      <span className="text-brandred mt-1">{icon}</span>
      <div className="min-w-0 break-words">
        <div className="text-xs uppercase tracking-wider text-muted-foreground">{title}</div>
        {lines.map((l, i) => <div key={i} className="font-medium text-navy [overflow-wrap:anywhere]" data-testid={`${testid}-line-${i}`}>{l}</div>)}
      </div>
    </div>
  );
  return href ? <a href={href} data-testid={`${testid}-link`} className="block" target={href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer">{inner}</a> : inner;
}
